import {Component, inject} from '@angular/core';
import {ImportSessionStore} from '../import-session.store';
import {rowCountText} from '../row-count';

/**
 * The Feltkoblinger tab's Forhåndsvisning: a row of the table, picked with
 * a stepper, as the object it becomes - its identification number and
 * object type, its title, the mapped fields' values and the lines the row
 * gives nothing - and a jump to the next row the Forhåndskontroll found a
 * warning on.
 */
@Component({
  selector: 'app-import-live-preview',
  templateUrl: './import-live-preview.component.html',
  styleUrls: ['./import-live-preview.component.scss'],
  standalone: false,
})
export class ImportLivePreviewComponent {
  readonly store: ImportSessionStore = inject(ImportSessionStore);
  readonly rowCountText = rowCountText;

  /** Asks for the row typed into the row box; anything but a number puts
   * the box back to the row asked for. */
  onRowTyped(input: HTMLInputElement): void {
    const row = Number(input.value);
    if (Number.isFinite(row)) {
      this.store.setLivePreviewRow(row);
    }
    input.value = String(this.store.livePreviewRow);
  }

  /** How many digits the row box is wide for: the table's last row's, or
   * the row asked for's where that is longer; six while the table's row
   * count is not in. */
  get rowBoxDigits(): number {
    const lastRow = this.store.livePreviewRowCount?.rows ?? 999_999;
    return String(Math.max(lastRow, this.store.livePreviewRow)).length;
  }

  /** Whether the row asked for is the table's last one, by its exact
   * count. */
  get atLastRow(): boolean {
    const count = this.store.livePreviewRowCount;
    return !!count?.exact && this.store.livePreviewRow >= count.rows;
  }
}
